<template>
    <b-button
        variant="primary"
        @click.stop="confirmarResetarSenha()"
        class="mr-2"
    >
        <i class="fa fa-key"></i> Resetar Senha
    </b-button>
</template>

<script>
import UsuariosServicos from './UsuariosServicos'
import UsuariosFornecedorServicos from './UsuariosFornecedorServicos'
import FornecedoresUsuariosServicos from './../../fornecedor/usuarios/UsuariosServicos'

export default {
    props: {
        usuario: {
            type: Object,
            required: true
        },

        fornecedor: {
            type: Boolean,
            default: false
        },

        gestaoInterna: {
            type: Boolean,
            default: () => false
        }
    },

    methods: {
        confirmarResetarSenha() {
            this.$swal({
                title: 'Reset de Senha',
                html: `Confirma o reset da senha do usuário <b>${this.usuario.nome}</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.resetarSenha()
                }
            })
        },

        resetarSenha() {
            this.$store.dispatch('addRequest')
            let promisse
            if (this.fornecedor) {
                promisse = FornecedoresUsuariosServicos.resetarSenhaUsuario(
                    this.$route.params.usuarioId
                )
            } else if (this.gestaoInterna) {
                promisse = UsuariosFornecedorServicos.resetarSenhaUsuario(
                    this.$route.params.fornecedorId,
                    this.$route.params.usuarioId
                )
            } else {
                promisse = UsuariosServicos.resetarSenhaUsuario(
                    this.$route.params.usuarioId
                )
            }
            promisse.then((response) => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Reset de senha realizado com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                    } else {
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    }
}
</script>
